





































































import Vue, { PropType } from 'vue';

import FieldCheckbox from '@/components/form/FieldCheckbox.vue';
import Preloader from '@/components/preloader/Preloader.vue';

const LOCAL_STORAGE_EXPAND_SELECTED_SERIES =
  'tffSelectedSeriesDetailStatistics';

export default Vue.extend({
  name: 'DetailStatistics',
  components: { FieldCheckbox, Preloader },
  props: {
    data: {
      type: Object as PropType<any>,
      default: () => ({}),
    },
    loadData: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.getFromLocalStorage();
  },
  watch: {
    data() {
      this.getFromLocalStorage();
    },
  },
  computed: {
    chartOptions(): any {
      return {
        chart: {
          type: 'area',
          backgroundColor: '#E3E5F0',
        },
        title: { text: 'ID ' + this.data.campaignId, y: 5 },
        legend: {
          enabled: true,
          align: 'left',
          layout: 'horizontal',
          verticalAlign: 'top',
          padding: 15,
          floating: true,
        },
        rangeSelector: {
          enabled: false,
        },
        xAxis: {
          categories: this.data.periodCategory,
        },
        yAxis: {
          opposite: false,
        },
        plotOptions: {
          series: {
            marker: {
              enabled: true,
              radius: 3,
            },
            fillOpacity: 0.2,
          },
        },
        series: this.filteredChartSeries,
      };
    },
    filteredChartSeries(): Array<any> {
      return this.data.series.filter(s => this.selectedSeries.includes(s.name));
    },
    chartSeriesList(): Array<any> {
      return this.data.series.map(s => s.name);
    },
  },
  methods: {
    showSeriesList() {
      this.isShowSeriesList = !this.isShowSeriesList;
    },
    hideSeriesList() {
      this.isShowSeriesList = false;
    },
    isSeriesItemChecked(seriesItem) {
      return this.selectedSeries.includes(seriesItem);
    },
    addSeriesToSelected(seriesItem) {
      const index = this.selectedSeries.indexOf(seriesItem);

      if (index >= 0) {
        this.selectedSeries.splice(index, 1);
        this.saveToLocalStorage();
        return;
      }

      this.selectedSeries.push(seriesItem);
      this.saveToLocalStorage();
    },
    saveToLocalStorage() {
      window.localStorage.setItem(
        LOCAL_STORAGE_EXPAND_SELECTED_SERIES,
        window.btoa(JSON.stringify(this.selectedSeries))
      );
    },
    getFromLocalStorage() {
      const selectedSeries = window.localStorage.getItem(
        LOCAL_STORAGE_EXPAND_SELECTED_SERIES
      );
      if (selectedSeries) {
        try {
          this.selectedSeries = JSON.parse(window.atob(selectedSeries));
        } catch (err) {
          console.error('Parse selectedSeries: ', err);
        }
        return;
      }

      if (this.data?.series?.length) {
        this.selectedSeries.push(this.data.series[0]?.name);
      }
    },
  },
  data() {
    return {
      selectedSeries: [] as Array<string>,
      isShowSeriesList: false,
    };
  },
});
